import React from 'react';
export function ArrowLeftIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M3.132 12l7.637 8.182 1.462-1.364-5.633-6.036L21 13v-2l-14.402.218 5.633-6.036-1.462-1.364L3.132 12z"
  }));
}